import React, { useContext, useEffect } from "react";
import AAutoComplete from "views/pages/manage/common/form-fields-mui/AAutoComplete";
import useCashierOfficeDropdown, {DIGITAL_BUSINESS_IDS} from "views/pages/manage/common/hook/useCashierOfficeDropdown";
import AButton from "views/pages/manage/common/form-fields-mui/AButton";
import "./style.scss";
import { PAGE_STATE, StudentListContext } from "../contextApi";
import {
  chargeStatusMapping,
  chargesStatueDropdown,
  paymentStatusDropdown,
} from "../common";
import { useDispatch, useSelector } from "react-redux";
// import { getStudentList } from "../../../../../../redux/studentCharges/actions";
import { failureToast } from "../../../common/utils/methods/toasterFunctions/function";
import { useGetCourseIdsForBUAndTerm } from "../../../edpOps/stockManagement/customhooks";
import { getUpdatedChargeStatus } from "./utils";
function getLabel(globalFilter) {
  if (
    globalFilter &&
    globalFilter.cashierOffice &&
    globalFilter.cashierOffice.label
  ) {
    return globalFilter.cashierOffice.label;
  } else {
    return null; // or any default value you want to return when both are null or undefined
  }
}
const StudentFilterForm = ({ studentContext, getStudentList, storeState }) => {
  const inputHeight = "42px";
  const marginTop = { marginTop: "33px" };
  const dispatch = useDispatch();
  const { globalFilter, setGlobalFilter, setCurrentPageState } =
    useContext(studentContext);
  const studentCharges = useSelector((state) => state[storeState]);
  const allBusinessAreaList = useSelector(
    (state) => state.globalData.masterDropdowns
  )?.allBusinessAreaList.map(({ label, businessAreaId }) => ({
    label,
    value: businessAreaId,
    businessAreaId,
  }));

  // const batchDropdown = useGetBatchList(
  //   dropdown?.businessAreas?.length === 1?dropdown?.businessAreas[0] :filterForm?.businessArea,
  //   filterForm?.term
  // );

  const formHandler = (key, value) => {
    setGlobalFilter((prev) => ({ ...prev, [key]: value }));
  };
  const { DropdownComponent,validateCashierOfficeAccess  } = useCashierOfficeDropdown({
    label: "Cashier office",
    formHandler,
    inputHeight,
    businessArea: globalFilter?.businessArea,
    cashierOffice: getLabel(globalFilter),
  });

  const fetchInitialList = () => {
    
    const filters = { ...globalFilter };
    
    const chargesStatusValuesArr = [filters.chargesStatus?.value]
    delete filters["psid"];
    delete filters["applicationId"];
    const request = {
      ...filters,
      chargesStatus: getUpdatedChargeStatus(chargesStatusValuesArr),
    }
    if(request?.chargesStatus?.includes("PROV")){
      delete request['cashierOffice']  ;
    }

    dispatch(
      getStudentList(
        request,
        0
      )
    );

    setGlobalFilter({ ...filters });
  };
  const validateBusinessRules = (globalFilter, showError) => {
    const currentBu = globalFilter?.businessArea?.[0]?.label ?? '';
  
    if (!currentBu && globalFilter?.chargesStatus?.value !== "PROV") {
      return showError("Please select business area");
    }
  
    if (DIGITAL_BUSINESS_IDS.includes(currentBu) && (!globalFilter?.cashierOffice) && globalFilter?.chargesStatus?.value !== "PROV") {
      return showError("Please select cashier office");
    }
  
    return true;
  };
  

  const setFilterAndCallApi = async () => {
    const excludedKeys = ["searchField", "psid", "applicationId"];
    
    const hasFilterValues = Object.keys(globalFilter)
      .filter((key) => !excludedKeys.includes(key))
      .some((key) => Array.isArray(globalFilter[key]) && globalFilter[key].length > 0);
  
    const isFilterApplied = hasFilterValues || Boolean(globalFilter?.chargesStatus?.label);
  
    const showError = (msg) => {
      failureToast(msg);
      return false;
    };
  
    if (!validateBusinessRules(globalFilter, showError)) return;
  
    if (!isFilterApplied) {
      return showError("Please provide at least one filter to search");
    }
  
    try {
       fetchInitialList();
      setCurrentPageState(PAGE_STATE.LIST_STUDENT);
    } catch (err) {
      failureToast("Failed to fetch student list");
    }
  };

  const [courseIdDropdown, courseIdDropdownLoading] =
    useGetCourseIdsForBUAndTerm({
      businessArea: globalFilter?.businessArea?.[0],
      term: globalFilter?.term?.[0],
    });

  const styles = {
    display: "grid",
    gridTemplateColumns: "repeat(6,minmax(120px, 1fr))",
    gap: "16px",
    alignItems: "center",
  };

  const applicationStatusDropdown = chargesStatueDropdown.map((item) => ({
    ...item,
    label: `${item.label} (${chargeStatusMapping[item.label]})`,
  }));

  return (
    <div style={styles} className="mt-4 mb-2">
      <div>
        <AAutoComplete
          label="Business Area"
          height={inputHeight}
          placeholder="Business Area"
          isMulti={false}
          // isShowCount={true}
          items={allBusinessAreaList ?? []}
          currentValue={globalFilter?.businessArea}
          handleChange={(value) => {
            formHandler("businessArea", [value]);
          }}
        />
      </div>
      {DropdownComponent}
      <div>
        <AAutoComplete
          label="Term"
          height={inputHeight}
          placeholder="Term"
          // items={dropdown?.terms}
          // isShowCount={true}
          isMulti={false}
          items={studentCharges?.dropdowns?.term ?? []}
          currentValue={globalFilter?.term}
          handleChange={(value) => {
            formHandler("term", [value]);
          }}
        />
      </div>

      <div>
        <AAutoComplete
          height={inputHeight}
          label="Course Id"
          placeholder="Course Id"
          isMulti={true}
          isShowCount={true}
          items={courseIdDropdown}
          currentValue={globalFilter?.courseId}
          handleChange={(value) => {
            formHandler("courseId", value);
          }}
          selectAllMenuButton={false}
          isLoading={courseIdDropdownLoading}
        />
      </div>
      <div>
        <AAutoComplete
          height={inputHeight}
          label="Charge Status"
          placeholder="Charge Status"
          items={applicationStatusDropdown}
          isShowCount={true}
          isMulti={false}
          currentValue={globalFilter?.chargesStatus}
          style={{ menuPortal: { width: "290px" } }}
          handleChange={(value) => {
            formHandler("chargesStatus", value);
          }}
        />
      </div>
      {/* <div>
        <AAutoComplete
          height={inputHeight}
          label="Payment Status"
          placeholder="Payment Status"
          items={paymentStatusDropdown}
          isShowCount={true}
          currentValue={globalFilter?.paymentStatus}
          handleChange={(value) => { formHandler("paymentStatus", value) }}
        />
      </div> */}

      <div style={marginTop}>
        <AButton
          className="button_remove_left_margin"
          updatedStyle={{ fontSize: "12px", width: "100%" }}
          onClick={setFilterAndCallApi}
          variant="primary_filled"
        >
          Apply
        </AButton>
      </div>
    </div>
  );
};

export default StudentFilterForm;
